import * as Yup from 'yup';
import { type CompanyDto } from '@/app/models/CompanyDto';
import { type CompanySummaryDto } from '@/app/models/CompanySummaryDto';

export const canChooseCompany = (activeCompanies: CompanyDto[]) => activeCompanies.length > 1;

export const chosenCompany = (
  activeCompanies: CompanyDto[],
  chosen?: CompanyDto | null,
): CompanySummaryDto | undefined => {
  const id = canChooseCompany(activeCompanies) ? chosen?.id : activeCompanies[0]?.id;
  return id ? { id } : undefined;
};

export const withRequiredCompany = (schema: Yup.AnyObjectSchema, activeCompanies: CompanyDto[]) =>
  canChooseCompany(activeCompanies)
    ? schema.shape({ company: Yup.object().required('Empresa é obrigatória') })
    : schema;
